import {useEffect, useState} from "react";
import info from "../assets/info-icon.png";
import ROIBarChartPillar from "./ROIBarChartPillar";


const ROIBarChart = (props) => {

    const [data, setData] = useState([])
    const [benchmark, setBenchmark] = useState([0, 0, 0, 0, 0, 0])
    const [benchmarkEnabled, setBenchmarkEnabled] = useState(false)
    const [showTitleHover, setShowTitleHover] = useState(false)
    const [barPopupLeft, setBarPopupLeft] = useState(0)
    const [showBarPopup, setShowBarPopup] = useState(false)
    const [initAvg, setInitAvg] = useState(0)
    const [endAvg, setEndAvg] = useState(0)
    const teams = Array.isArray(props.teams) ? props.teams : [];

    useEffect(() => {
        setData(props.data)
    }, [props.data]);

    useEffect(() => {
        setBenchmark(props.benchmark)
    }, [props.benchmark]);

    const getPillarColour = (pillar_id) => {
        switch (pillar_id) {
            case 1: return "pillar-blue"
            case 2: return "pillar-red"
            case 3: return "pillar-green"
            case 4: return "pillar-purple"
            case 5: return "pillar-pink"
            case 6: return "pillar-orange"
        }
    }

    const getLiteralPillarColour = (pillar_id) => {
        switch (pillar_id) {
            case 1: return "#0082CA"
            case 2: return "#C11B20"
            case 3: return "#93D500"
            case 4: return "#773DBD"
            case 5: return "#F478C4"
            case 6: return "#F08019"
        }
    }

    const getLiteralPillarBorder = (pillar_id) => {
        switch (pillar_id) {
            case 1: return "#065683"
            case 2: return "#4B0F11"
            case 3: return "#227B17"
            case 4: return "#351B53"
            case 5: return "#8E5076"
            case 6: return "#794C22"
        }
    }

    const getBenchmarkPillarColour = (pillar_id) => {
        switch (pillar_id) {
            case 1: return "#9DDCFF"
            case 2: return "#FFA1A2"
            case 3: return "#E4FCAE"
            case 4: return "#D9BAFE"
            case 5: return "#FFD9F0"
            case 6: return "#FFDBB9"
        }
    }

    const getBenchmarkPillarBorder = (pillar_id) => {
        switch (pillar_id) {
            case 1: return "rgba(0, 130, 202, 0.49)"
            case 2: return "rgba(193, 27, 32, 0.24)"
            case 3: return "rgba(147, 213, 0, 0.21)"
            case 4: return "rgba(119, 61, 189, 0.18)"
            case 5: return "rgba(244, 120, 196, 0.27)"
            case 6: return "rgba(240, 128, 25, 0.38)"
        }
    }

    const getPillarName = (pillar_id) => {
        switch (pillar_id) {
            case 1: return "Purpose & Motivation"
            case 2: return "External Systems & Processes"
            case 3: return "Relationships"
            case 4: return "Internal Systems & Processes"
            case 5: return "Learning"
            case 6: return "Leadership"
        }
    }

    const normal_round = (value) => {
        if (!value) return;
        if (value - Math.floor(value) < 0.5) return Math.floor(value);
        return Math.ceil(value)
    }

    const getBarPositions = (pillar, idx) => {
        let barHeight;
        let left;
        let right;
        let top;
        let bottom;
        let improvement = pillar.data.average_change
        if (improvement > 80) {
            barHeight = "400%"
        } else if (improvement < -20) {
            barHeight = "100%"
        } else {
            barHeight = `${Math.abs((5/6 * 500) * (improvement / 100))}px`
        }

        if (benchmarkEnabled) {
            left = "calc(50% - 42px)"
            right = "calc(50% - 2px)"
        } else {
            left = "calc(50% - 20px)"
            right = "calc(50% + 20px)"
        }

        if (improvement >= 0) {
            bottom = 0
            top = "unset"
        } else {
            top = "100%"
            bottom = "unset"
        }

        return {
            "height": barHeight,
            "left": left,
            "right": right,
            "top": top,
            "bottom": bottom,
            "init_avg": `${(pillar.data.initial_average)}`,
            "end_avg": `${(pillar.data.endpoint_average)}`,
            "colour": getLiteralPillarColour(idx + 1),
            "text": `${Math.round(improvement)}%`,
            "border_colour": getLiteralPillarBorder(idx + 1)
        }
    }

    const getBenchmarkPosition = (idx) => {
        let improvement = benchmark[idx]
        let barHeight;
        let left;
        let right;
        let bottom;
        let top;

        if (improvement > 80) {
            barHeight = "400%"
        } else if (improvement < -20) {
            barHeight = "100%"
        } else {
            barHeight = `${Math.abs((4/5 * 500) * (improvement / 100))}px`
        }

        left = "calc(50% + 2px)"
        right = "calc(50% + 42px)"

        if (improvement >= 0) {
            bottom = 0
            top = "unset"
        } else {
            top = "100%"
            bottom = "unset"
        }

        return {
            "height": barHeight,
            "left": left,
            "right": right,
            "top": top,
            "bottom": bottom,
            "colour": getBenchmarkPillarColour(idx + 1),
            "border_colour": getBenchmarkPillarBorder(idx + 1),
            "text": `${improvement}%`
        }
    }

    const handleBarHover = (data, idx) => {
        if (!data) {
            setShowBarPopup(false)
            setBarPopupLeft(0)
        } else {
            let left = []
            if (!idx) {left.push(-10)} else {left.push(-10 + idx * 155.89)}
            setBarPopupLeft(left[0])
            setInitAvg(data.init_avg)
            setEndAvg(data.end_avg)
            setShowBarPopup(true)
        }

    }

    return (
        <div className="roi-graphical-container">
            <div className="roi-barchart-title-container">
                <div className="summary-tabular-title">
                    Overall Performance Change (%) By Pillar
                    <img src={info} alt="Info"
                         onMouseOver={() => setShowTitleHover(true)}
                         onMouseLeave={() => setShowTitleHover(false)}
                    />
                    {showTitleHover ?
                        <div className="dashboard-roi-title-hover" style={{top: 42, left: 328}}>
                            <div className="dashboard-roi-title-hover-triangle-outer">
                                <div className="dashboard-roi-title-hover-triangle-inner"/>
                            </div>
                            <div className="dashboard-roi-title-hover-text regular">
                                This chart shows the aggregated percentage change over time of your PERILL scores by
                                Pillar for your qualifying teams. You can also toggle on the benchmarking data to
                                compare your teams performance metrics with other teams across the platform.
                            </div>
                        </div> : null
                    }
                </div>
                <div className="roi-barchart-benchmark-switch">
                    <div className={`chart-controls-switch ${benchmarkEnabled ? "active" : "inactive"}`}
                         onClick={() => setBenchmarkEnabled(!benchmarkEnabled)}>
                        <div className="chart-controls-switch-centre"/>
                    </div>
                    <div className="roi-barchart-benchmark-switch-text">Add Benchmarking Data</div>
                </div>
            </div>
            {teams.length > 0 ? (
                <>
                    <div className="roi-bar-chart-container">
                        <div className="roi-barchart-table-left-spacer">
                            <div className="roi-graphical-spacer-segment no-border">80%</div>
                            <div className="roi-graphical-spacer-segment no-border">60%</div>
                            <div className="roi-graphical-spacer-segment no-border">40%</div>
                            <div className="roi-graphical-spacer-segment no-border">20%</div>
                            <div className="roi-graphical-spacer-segment no-border">0%</div>
                            <div className="roi-graphical-spacer-segment no-border">-20%</div>
                        </div>
                        {data && data.map((pillar, idx) => {
                            let bar = getBarPositions(pillar, idx)
                            let benchmark = getBenchmarkPosition(idx)
                            let comparisonData = {"init_avg": bar.init_avg, "end_avg": bar.end_avg}
                            return(
                                <ROIBarChartPillar bar={bar}
                                                   benchmark={benchmark}
                                                   benchmarkEnabled={benchmarkEnabled}
                                                   idx={idx}
                                                   getPillarColour={getPillarColour.bind(this)}
                                                   getPillarName={getPillarName.bind(this)}
                                                   comparisonData = {comparisonData}
                                                   handleBarHover = {handleBarHover.bind(this)}
                                />
                            )
                        })}
                    </div>

                    {showBarPopup && (
                        <div className="roi-barchart-avg-popup-container" style={{ left: barPopupLeft }}>
                            <div className="roi-barchart-avg-popup">
                                <div className="roi-barchart-avg-popup-row">
                                    <div className="roi-barchart-avg-popup-row-text">Initial Average:</div>
                                    <div className="roi-barchart-avg-popup-row-value">{normal_round(initAvg)}</div>
                                </div>
                                <div className="roi-barchart-avg-popup-row">
                                    <div className="roi-barchart-avg-popup-row-text">Endpoint Average:</div>
                                    <div className="roi-barchart-avg-popup-row-value">{normal_round(endAvg)}</div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            ) : (
                <div className="roi-report-title-card-no-teams">No teams selected</div>
            )}
        </div>
    )
}


export default ROIBarChart